import { mapActions, mapGetters, mapState } from 'vuex';
import { isMarketSingle } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import marketRulesContent from '@/components/market/market-rules-content/market-rules-content.vue';

export default {
  components: {
    marketRulesContent,
  },
  props: {
    rules: String,
    dateEnd: String,
    market: {
      type: Object,
      required: true,
    },
    emphasize: {
      type: Boolean,
      default: false,
    },
    showExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: this.showExpanded,
    };
  },
  computed: {
    ...mapState('market', ['isRulesOpen']),
    ...mapGetters('app', ['isLayoutDesktop']),
    wrapperClass() {
      return {
        'market-rules__wrapper': true,
        'market-rules__wrapper--single': isMarketSingle(this.market),
      };
    },
    marginBoxClass() {
      return {
        'market-rules__box': true,
        'market-rules__box--margin': true,
      };
    },
  },
  methods: {
    ...mapActions('popup', ['setGenericSmallPopup']),
    showRulesPopup() {
      this.setGenericSmallPopup({
        name: MODALS.SMALL_MARKET_RULES,
        options: {
          title: 'The Rules',
          market: this.market,
        },
      });
    },
  },
  mounted() {
    if (this.emphasize) this.showRulesPopup();
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-rules/market-rules.js